__turbopack_context__.v({
  "card": "skewed-carousel-module__pGkf6a__card",
  "cardImage": "skewed-carousel-module__pGkf6a__cardImage",
  "cardImageDark": "skewed-carousel-module__pGkf6a__cardImageDark",
  "cardImageLight": "skewed-carousel-module__pGkf6a__cardImageLight",
  "group": "skewed-carousel-module__pGkf6a__group",
  "inFlow": "skewed-carousel-module__pGkf6a__inFlow",
  "lift": "skewed-carousel-module__pGkf6a__lift",
  "marquee": "skewed-carousel-module__pGkf6a__marquee",
  "marqueeRtl": "skewed-carousel-module__pGkf6a__marqueeRtl",
  "root": "skewed-carousel-module__pGkf6a__root",
  "rtl": "skewed-carousel-module__pGkf6a__rtl",
  "scene": "skewed-carousel-module__pGkf6a__scene",
  "slide": "skewed-carousel-module__pGkf6a__slide",
  "track": "skewed-carousel-module__pGkf6a__track",
  "trackReady": "skewed-carousel-module__pGkf6a__trackReady",
  "viewport": "skewed-carousel-module__pGkf6a__viewport",
});
